<template>
  <footer class="page-footer">
    <BaseContainer>
      <div class="page-footer__share">
        <MorrisonsLogo />
        <ShareLinksFooter class="page-footer__icons" />
      </div>
      <div class="page-footer__links">
        <div class="page-footer__row">
          <div class="page-footer__col">
            <div
              class="page-footer__expander"
              :class="{ isActive: openPanel == 0 }"
            >
              <h4 class="page-footer__title">
                <span class="hidden md:block">Our Main Sites</span>
                <button class="md:hidden" @click="open(0)">
                  <BaseIconText iconAfter="add" size="16"
                    >Our Main Sites</BaseIconText
                  >
                </button>
              </h4>
              <div
                class="page-footer__wrapper"
                :class="{ isActive: openPanel == 0 }"
              >
                <a
                  href="https://groceries.morrisons.com/webshop/startWebshop.do"
                  >Groceries</a
                >
                <a
                  href="https://my.morrisons.com/foodtoorder/?utm_source=groceries&utm_medium=internal&utm_campaign=footer_link"
                  >Food to Order</a
                >
                <a
                  href="https://www.morrisons.com/eatfresh/?utm_source=groceries&utm_medium=internal&utm_campaign=footer_link"
                  >Eat Fresh</a
                >
                <a
                  href="https://my.morrisons.com/more/?utm_source=groceries&utm_medium=internal&utm_campaign=footer_link"
                  >Morrisons More</a
                >
                <a
                  href="https://my.morrisons.com/?utm_source=groceries&utm_medium=internal&utm_campaign=footer_link"
                  >Blog</a
                >
              </div>
            </div>
          </div>
          <div class="page-footer__col">
            <div
              class="page-footer__expander"
              :class="{ isActive: openPanel == 1 }"
            >
              <h4 class="page-footer__title">
                <span class="hidden md:block">Help & Information</span>
                <button class="md:hidden" @click="open(1)">
                  <BaseIconText iconAfter="add" size="16"
                    >Help & Information</BaseIconText
                  >
                </button>
              </h4>
              <div
                class="page-footer__wrapper"
                :class="{ isActive: openPanel == 1 }"
              >
                <a
                  href="https://my.morrisons.com/help/?utm_source=groceries&utm_medium=Internal&utm_campaign=footer_link"
                  >Contact Us</a
                >
                <a
                  href="https://my.morrisons.com/storefinder/?utm_source=groceries&utm_medium=Internal&utm_campaign=footer_link"
                  >Store Finder</a
                >
                <a
                  href="https://my.morrisons.com/help/information/store-services/?utm_source=groceries&utm_medium=Internal&utm_campaign=footer_link"
                  >Store Services</a
                >
                <a
                  href="https://my.morrisons.com/help/?utm_source=groceries&utm_medium=Internal&utm_campaign=footer_link"
                  >FAQ’s</a
                >
              </div>
            </div>
          </div>
          <div class="page-footer__col">
            <div
              class="page-footer__expander"
              :class="{ isActive: openPanel == 2 }"
            >
              <h4 class="page-footer__title">
                <span class="hidden md:block">Corporate</span>
                <button class="md:hidden" @click="open(2)">
                  <BaseIconText iconAfter="add" size="16"
                    >Corporate</BaseIconText
                  >
                </button>
              </h4>
              <div
                class="page-footer__wrapper"
                :class="{ isActive: openPanel == 2 }"
              >
                <a
                  href="https://www.morrisons-corporate.com/about-us/?utm_source=groceries&utm_medium=Internal&utm_campaign=footer_link"
                  >About Us</a
                >
                <a
                  href="https://www.morrisons-corporate.com/cr/?utm_source=groceries&utm_medium=Internal&utm_campaign=footer_link"
                  >Corporate Responsibility</a
                >
                <a
                  href="https://www.morrisons-corporate.com/investor-centre/?utm_source=groceries&utm_medium=Internal&utm_campaign=footer_link"
                  >Investor Centre</a
                >
                <a
                  href="https://www.morrisons.jobs/?utm_source=groceries&utm_medium=Internal&utm_campaign=footer_link"
                  >Jobs</a
                >
                <a
                  href="https://www.morrisons-corporate.com/Documents/corporate2018/Morrisons_Modern-Slavery-Act-2018.pdf?utm_source=groceries&utm_medium=Internal&utm_campaign=footer_link"
                  >Modern Slavery Statement</a
                >
              </div>
            </div>
          </div>
          <div class="page-footer__col">
            <div
              class="page-footer__expander"
              :class="{ isActive: openPanel == 3 }"
            >
              <h4 class="page-footer__title">
                <span class="hidden md:block">Terms</span>
                <button class="md:hidden" @click="open(3)">
                  <BaseIconText iconAfter="add" size="16">Terms</BaseIconText>
                </button>
              </h4>
              <div
                class="page-footer__wrapper"
                :class="{ isActive: openPanel == 3 }"
              >
                <a
                  href="https://groceries.morrisons.com/webshop/scontent/termsOfUse"
                  >Terms of Use</a
                >
                <a
                  href="https://groceries.morrisons.com/webshop/scontent/termsAndConditions"
                  >Terms & Conditions</a
                >
                <a
                  href="https://my.morrisons.com/privacy-policy/?utm_source=groceries&utm_medium=Internal&utm_campaign=footer_link"
                  >Privacy Policy</a
                >
                <a
                  href="https://my.morrisons.com/cookie-policy/?utm_source=groceries&utm_medium=Internal&utm_campaign=footer_link"
                  >Cookie Policy</a
                >
                <a
                  href="https://my.morrisons.com/weee-regulations/?utm_source=groceries&utm_medium=internal&utm_campaign=footer_link"
                  >WEEE Regulations</a
                >
                <a
                  href="https://my.morrisons.com/accessibility/?utm_source=groceries&utm_medium=internal&utm_campaign=footer_link"
                  >Accessibility</a
                >
              </div>
            </div>
          </div>
        </div>
        <span>© 2019 All rights reserved. Morrisons Ltd</span>
      </div>
    </BaseContainer>
  </footer>
</template>

<script>
import BaseIconText from '../elements/BaseIconText.vue'
import ShareLinksFooter from './ShareLinksFooter.vue'
import BaseContainer from '../elements/BaseContainer.vue'
import MorrisonsLogo from '@/assets/svg/logo-morrisons-white-text.svg?inline'
export default {
  name: 'TheFooter',
  components: {
    MorrisonsLogo,
    BaseContainer,
    ShareLinksFooter,
    BaseIconText
  },
  data() {
    return {
      openPanel: null
    }
  },
  methods: {
    open(id) {
      this.openPanel = id
    }
  }
}
</script>

<style lang="postcss">
.page-footer {
  @apply bg-body-dark py-8;
}
.page-footer__share {
  @apply flex flex-col items-center mb-10;
}
.page-footer__links {
  @apply text-white;
}
.page-footer__row {
  @apply -mx-4;
}
.page-footer__col {
  @apply px-4 pb-4;
}
.page-footer__wrapper {
  @apply overflow-hidden;
  max-height: 0;
}
.page-footer__wrapper.isActive {
  max-height: 160px;
}
.page-footer__wrapper a {
  @apply block text-white no-underline;
}
.page-footer__expander {
  @apply border-b border-white pb-4;
}
.page-footer__title button,
.page-footer__title {
  @apply text-tertiary font-semibold w-full outline-none;
}
.page-footer__title button:focus {
  @apply outline-none;
}
.page-footer__icons {
  @apply pt-4;
}

@screen md {
  .page-footer__row {
    @apply flex;
  }
  .page-footer__wrapper {
    @apply block max-h-full;
  }
  .page-footer__expander {
    @apply border-b-0;
  }
  .page-footer__share {
    @apply flex flex-row mb-6;
  }
  .page-footer__icons {
    @apply ml-auto pt-0;
  }
}

@screen md {
  .page-footer__col {
    @apply w-6/12 pb-8;
  }
}

@screen lg {
  .page-footer__col {
    @apply w-2/12;
  }
}
</style>
